import { Icon } from "@mui/material";
import React from "react";
import ReactSelect, { components, ControlProps, Props } from "react-select";
import CreatableSelect from "react-select/creatable";
import styled, { css } from "styled-components";
import theme from "../styles/theme";
import Pill from "./Pill";

// FIXME: why didn't overriding isMulti work?
export type SelectBoxProps = Props & {
  multi?: boolean;
  setClass?: string;
};

const sharedStyle = css`
  display: inline-block;
  width: 100%;
  .react-select__indicators {
    margin-left: 0px;
    height: 40px;
    gap: ${({ theme }) => theme.spacing.xs};
  }

  .react-select__indicator {
    &.react-select__dropdown-indicator {
      color: ${theme.color.lightBlueGray800};
      padding: 0;
    }
    &.react-select__clear-indicator {
      color: white;
      padding: 0;
    }
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__value-container {
    padding: 0;
  }

  .react-select__control {
    background: white;
    padding: 0 10px;
    border: 1px solid theme.color.lightBlueGray800;
    outline: none;
    box-shadow: none;
    min-height: none;
    cursor: pointer;
  }

  .react-select__placeholder {
    margin: 0;
    position: relative;
    transform: none;
    color: ${({ theme }) => theme.color.textMuted};
  }

  .react-select__input {
    width: unset;
    margin: 0;
  }

  .react-select__menu {
    min-width: ${({ theme }) => theme.spacing.base * 20}px;
    margin: 0;
    position: absolute;
    z-index: 99999;
  }

  .react-select__value-container {
    padding: 0 ${({ theme }) => theme.spacing.xs};
  }
  .react-select__option {
    color: black;
    font-size: 14px;
  }
  .react-select__menu {
    position: absolute;
    backdrop-filter: blur(35px);
    z-index: 999;
  }
  .react-select__single-value {
    color: ${theme.color.lightBlueGray800};
    font-size: 14px;
    position: relative;
    transform: none;
    max-width: none;
    margin: 0;
    padding: 8px 4px;
    vertical-align: text-bottom;
  }

  .react-select__multi-value {
    font-size: 11px;
    background: white !important;
    padding: 0px 5px;
    box-shadow: 0 0 2px #d6d7d8;
  }
  .react-select__option--is-selected {
    color: white;
  }
  .react-select__single-value__label {
    color: unset;
    margin: 0;
  }

  .react-select__multi-value__label {
    color: inherit;
    padding: 0;
    font-size: inherit;
  }

  .react-select__multi-value__remove {
    color: inherit;
    padding: 0;
    font-size: inherit;

    &:hover {
      background: transparent;
      color: ${({ theme }) => theme.color.danger};
    }
  }
`;

const StyledReactSelect = styled(ReactSelect)`
  ${sharedStyle}
`;

const StyledCreatableSelect = styled(CreatableSelect)`
  ${sharedStyle}
`;

const StyledBasicSelect = styled(ReactSelect)`
  ${sharedStyle}
`;
const MultiValueContainer = (props: any) => (
  <Pill>
    <components.MultiValueContainer {...props} />
  </Pill>
);

const MultiValueRemove = (props: any) => (
  <components.MultiValueRemove {...props}>
    {/* <Icon>keyboard_arrow_down</Icon> */}
  </components.MultiValueRemove>
);

const DropdownIndicator = (props: any) => (
  <components.DropdownIndicator {...props}>
    <Icon sx={{ fontSize: "1.5em" }}>keyboard_arrow_down</Icon>
  </components.DropdownIndicator>
);

const ClearIndicator = (props: any) => (
  <components.DropdownIndicator {...props}>
    <Icon>keyboard_arrow_down</Icon>
  </components.DropdownIndicator>
);
const Control = ({ children, ...props }: ControlProps<any>) => {
  return <components.Control {...props}>{children}</components.Control>;
};

const SelectBox = ({ multi, setClass, ...props }: SelectBoxProps) => (
  <StyledReactSelect
    className={setClass}
    classNamePrefix="react-select"
    components={{
      Control,
      MultiValueContainer,
      MultiValueRemove,
      DropdownIndicator,
      ClearIndicator,
    }}
    isMulti={multi}
    {...props}
  />
);

export const SelectBoxCreatable = ({
  multi,
  ...props
}: SelectBoxProps) => (
  <StyledCreatableSelect
    classNamePrefix="react-select"
    components={{
      MultiValueContainer,
      MultiValueRemove,
      DropdownIndicator,
      ClearIndicator,
    }}
    isMulti={multi}
    {...props}
  />
);

export const BasicSelect = ({ multi, setClass, ...props }: SelectBoxProps) => (
  <StyledBasicSelect
    className={setClass}
    classNamePrefix="react-select"
    components={{
      Control,
      MultiValueContainer,
      MultiValueRemove,
      DropdownIndicator,
      ClearIndicator,
    }}
    isMulti={multi}
    {...props}
  />
);

export default SelectBox;
